<template>
  <div class="recommend" v-if="data.length">
    <div class="r-title">推荐阅读</div>
    <div class="r-list">
      <div
        class="r-item"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <img class="r-image" :src="item.detail.cover_image.url" alt="" />
        <div class="r-right">
          <div class="r-name">{{ item.base.title }}</div>
          <div class="r-read"
            >{{ item.detail.total_pv || 0 }} 阅读 ·
            {{ item.base.like_info.number || 0 }}点赞</div
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      let url =
        location.origin +
        location.pathname +
        '?tab_type=' +
        item.detail.tab_type +
        '&tid=' +
        item.detail.id
      this.$betterwe.onAppPageUrlRoute('/web?url=' + encodeURIComponent(url))
      /* this.$router.push({
                path:"/article-detail",
                query:{
                    tab_type:item.tab_type,
                    tid:item.id
                },
            }); */
    }
  }
}
</script>
<style lang="scss" scoped>
.recommend {
  background-color: #fff;
  padding: 16px 16px 20px;

  .r-title {
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 21px;
    margin-bottom: 20px;
  }

  .r-list {
    .r-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .r-image {
        width: 64px;
        height: 64px;
        border-radius: 8px;
        object-fit: cover;
        overflow: hidden;
        margin-right: 16px;
      }

      .r-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .r-name {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 21px;
          margin-bottom: 4px;
        }

        .r-read {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
        }
      }
    }
    .r-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
